module.exports = __webpack_public_path__ + "img/LS.864bb371.png";